















































































import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import VueQr from 'vue-qr';
import qs from 'qs';
import { Toast } from 'vant';

@Component({ components: { VueQr } })
export default class Home extends Vue {
  stuname: any = '';
  schname: any = '';
  realschname: string = '';
  prelive: boolean = false;
  istocket: boolean = false;
  ordertrun: boolean = false;
  qrCode: any = '';
  qrData: any = '';
  qrnotice: any = '';
  qrlogo: any = '';
  async mounted() {
    const qrinfo = window.localStorage.getItem('qrinfo');
    if (!qrinfo) {
      Toast('数据过期请重新好获取！');
      // this.$router.push('active');
      return;
    } else {
      const qrdata: any = qs.parse(qrinfo);
      this.stuname = qrdata.name;
      this.schname = qrdata.realname;
      this.qrData = qrdata.HXM;
      this.qrnotice = qrdata.ZYSX.replaceAll('\n', '<br />');
      this.qrlogo = qrdata.TB;
    }
  }
  showTrunOrder() {
    // this.ordertrun = true;
    window.location.href =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05e6d2a47e3abdf6&redirect_uri=http%3A%2F%2Fapi.maka.im%2Fworks%2Fapi%2Fv1%2Fwechat%2Foauth-callback%3Furl%3Dhttps%253A%252F%252Fu603753753.viewer.maka.im%252Fwx%252Fpreset%252F603753753%252FDA1KHS0SW603753753%252Fu603753753.viewer.maka.im%253Fhash%253D228273869b0dba8dc0cb12a620501e79&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect';
  }
  gohome() {
    this.$router.push('home');
  }
  gettocket() {
    window.location.href = 'https://wap.cq.10086.cn/z/zdysjbhl.htm';
  }
  preliving() {
    // this.prelive = true;
    window.location.href = 'https://mzone.cqcb.com/schoolSearch';
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
